import PropTypes from "prop-types";
import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

const style = {
  infoGrid: {
    background: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    display: "grid",
    gridColumnGap: "20px",
    gridRowGap: "5px",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    width: "100%",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  },
};

function InfoGrid({ children, classes }) {
  return (
    <div className={classes.infoGrid}>
      {children}
    </div>
  );
}

InfoGrid.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(InfoGrid);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Grid/InfoGrid.jsx